var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_11548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12H24V8C24 3.588 20.412 0 16 0C11.588 0 8 3.588 8 8V12H7C5.34667 12 4 13.3453 4 15V29C4 30.6547 5.34667 32 7 32H25C26.6533 32 28 30.6547 28 29V15C28 13.3453 26.6533 12 25 12ZM10.6667 8C10.6667 5.05867 13.0587 2.66667 16 2.66667C18.9413 2.66667 21.3333 5.05867 21.3333 8V12H10.6667V8ZM17.3333 22.296V25.3333C17.3333 26.0693 16.7373 26.6667 16 26.6667C15.2627 26.6667 14.6667 26.0693 14.6667 25.3333V22.296C13.8733 21.8333 13.3333 20.9827 13.3333 20C13.3333 18.5293 14.5293 17.3333 16 17.3333C17.4707 17.3333 18.6667 18.5293 18.6667 20C18.6667 20.9827 18.1267 21.8333 17.3333 22.296Z",
    fill: "#ED2024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_11548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.dc465cfcdf411118d507c4d2b95df819.svg";
export { ForwardRef as ReactComponent };